import { centsToDollars } from "legacy/helpers.es6"
import EditDiscountsModal from "legacy/manage/EditDiscountsModal"
import PropTypes from "prop-types"
import React from "react"

class DiscountSection extends React.Component {
  constructor(props) {
    super(props)
    this.discountTable = this.discountTable.bind(this)
    this.discountRow = this.discountRow.bind(this)
  }

  discountTable() {
    if (this.props.discounts.length === 0 || this.props.disabled) {
      return null
    }

    return <div>{this.props.discounts.map(this.discountRow)}</div>
  }

  discountRow(discount) {
    if (discount._discount_text) {
      return (
        <div
          key={discount._internal_js_id}
          className="bs-p-3 bs-mt-2 rounded border"
        >
          <div>{discount._discount_text}</div>
          <span>
            <button
              className="btn btn-outline-danger btn-danger bs-mt-2"
              type="button"
              onClick={() =>
                this.props.removeDiscount(discount._internal_js_id)
              }
            >
              Delete
            </button>
          </span>
        </div>
      )
    } else {
      return (
        <div
          key={discount._internal_js_id}
          className="bs-p-3 bs-mt-2 rounded border"
        >
          <div>
            <span className="font-semibold">Kind:</span> {discount.kind}
          </div>
          <div>
            <span className="font-semibold">Category:</span>{" "}
            {discount.category === "total"
              ? "Dockage & Electric"
              : discount.category}
          </div>
          <div>
            <span className="font-semibold">Amount:</span>{" "}
            {discount.total_amount_off > 0
              ? centsToDollars(discount.total_amount_off)
              : `${discount.percent_off * 100}%`}
          </div>
          <div>{discount.name}</div>
          <span>
            <button
              className="btn btn-outline-danger btn-danger bs-mt-2"
              type="button"
              onClick={() =>
                this.props.removeDiscount(discount._internal_js_id)
              }
            >
              Delete
            </button>
          </span>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <h4 className="bs-mt-0 font-semibold">Discounts</h4>
        <EditDiscountsModal
          addDiscountToForm={this.props.addDiscountToForm}
          spaceCategory={this.props.spaceCategory}
          disabled={this.props.disabled}
          btnClass="btn-secondary"
        />
        {this.discountTable()}
      </div>
    )
  }
}

DiscountSection.propTypes = {
  discounts: PropTypes.array.isRequired,
  removeDiscount: PropTypes.func.isRequired,
  addDiscountToForm: PropTypes.func.isRequired,
  spaceCategory: PropTypes.string,
  disabled: PropTypes.bool,
}

export default DiscountSection
